import React from 'react';
import { Link, useLocation } from 'react-router-dom';

// Sur la home : ancre native (gérée par le scroll fluide Lenis).
// Ailleurs : navigation vers la home + hash, résolue par le ScrollManager.
export const AnchorLink = ({ id, children, ...rest }) => {
  const { pathname } = useLocation();
  if (pathname === '/') {
    return <a href={`#${id}`} {...rest}>{children}</a>;
  }
  return <Link to={`/#${id}`} {...rest}>{children}</Link>;
};

export default AnchorLink;
